export default __webpack_public_path__ + "static/media/icon-google-play.2455f195.svg";